import React from 'react';

interface VideoIconProps {
  style?: React.CSSProperties;
}

const VideoIcon: React.FC<VideoIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Video Annotation</title>
      <g clipPath="url(#clip0)">
        <path d="M0 22.5v-15l4.329-2.499h4.329v22.5L0 22.5z" fill="#943CFF" />
        <path d="M12.99 0l12.99 7.5v5.001l-2.166 3.75L4.329 5.001 12.99 0z" fill="#FD9D52" />
        <path d="M25.98 22.5L12.99 30l-4.329-2.499-2.166-3.75 19.485-11.25V22.5z" fill="#DD45D3" />
        <path d="M8.661 17.499L0 22.5l8.661 5.001V17.499z" fill="#943CFF" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VideoIcon;
